import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { PedidoItemInterface } from "app/module/pedido-item-interface";
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PedidoItemService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public getOne(id: number): Observable<PedidoItemInterface[]> {
		return this.http.get<PedidoItemInterface[]>(`${this.url}pedido-itens/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public post(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}pedido-itens/create`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public put(data: any, id): Observable<any> {
		return this.http
			.put<any>(`${this.url}pedido-itens/update/${id}`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}
}
